import Vue from 'vue'
import Vuex from 'vuex'

import AdMetrics from './modules/metrics/AdMetrics'
import AdMetricsChart from './modules/metrics/AdMetricsChart'
import Advertiser from './modules/advertiser'
import Auth from './modules/auth'
import Banner from './modules/banner'
import CampaignDetails from './modules/campaign/CampaignDetails'
import CampaignList from './modules/campaign/CampaignList'
import CompanyList from './modules/company/CompanyList'
import Content from './modules/content/Content'
import CustomerTraffic from './modules/metrics/CustomerTraffic'
import DarkMode from './modules/app/DarkMode'
import DealDetails from './modules/deal/DealDetails'
import DealList from './modules/deal/DealList'
import DeviceDetails from './modules/device/DeviceDetails'
import DeviceIssueDetails from './modules/device_issue/DeviceIssueDetails'
import DeviceIssueList from './modules/device_issue/DeviceIssueList'
import DeviceIssueMetrics from './modules/device_issue/DeviceIssueMetrics'
import DeviceList from './modules/device/DeviceList'
import MFA from './modules/mfa'
import RetailerDetails from './modules/retailer/RetailerDetails'
import RetailerList from './modules/retailer/RetailerList'
import StoreDetails from './modules/store/StoreDetails'
import StoreList from './modules/store/StoreList'
import StoreSearch from './modules/pricing/StoreSearch'
import UserDetails from './modules/user/UserDetails'
import UserList from './modules/user/UserList'
import UserSwitcher from './modules/auth/UserSwitcher'
import VendorDetails from './modules/vendor/VendorDetails'
import VendorList from './modules/vendor/VendorList'
import VideoDetails from './modules/video/VideoDetails'
import VideoList from './modules/video/VideoList'
import WholesalerDetails from './modules/wholesaler/WholesalerDetails'
import WholesalerList from './modules/wholesaler/WholesalerList'

Vue.use(Vuex)

const modules = {
  AdMetrics,
  AdMetricsChart,
  Advertiser,
  Auth,
  MFA,
  Banner,
  CampaignDetails,
  CampaignList,
  Content,
  CompanyList,
  CustomerTraffic,
  DarkMode,
  DealDetails,
  DealList,
  DeviceIssueDetails,
  DeviceIssueList,
  DeviceIssueMetrics,
  DeviceDetails,
  DeviceList,
  RetailerDetails,
  RetailerList,
  StoreDetails,
  StoreList,
  StoreSearch,
  UserDetails,
  UserList,
  UserSwitcher,
  VendorDetails,
  VendorList,
  VideoDetails,
  VideoList,
  WholesalerDetails,
  WholesalerList,
}

const actions = {
  reset({ dispatch }) {
    dispatch('AdMetrics/reset')
    dispatch('AdMetricsChart/reset')
  },
}

const store = new Vuex.Store({
  modules,
  actions,
  // Warn if state is mutated outside of a mutation
  // https://vuex.vuejs.org/guide/strict.html
  // strict: process.env.NODE_ENV !== 'production',
})

Object.keys(modules).forEach((moduleName) => {
  // Dispatch the init action for each module, if one exists
  // Module **must** be namespaced for this to work
  if (modules[moduleName].actions && modules[moduleName].actions.init) {
    if (modules[moduleName].namespaced) {
      store.dispatch(`${moduleName}/init`)
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js